import { Row, Col, Card } from 'antd';
import styled from 'styled-components';
import { TABLET_WIDTH, TABLET_SMALL_WIDTH, CELLPHONE_LARGE_WIDTH } from 'commons/constants';
import { getTheme } from 'settings/theme/index';
import { FunctionComponent } from 'react';

const {
  noodera: { spacing },
} = getTheme();

export const StyledRow = styled(Row)`
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const StyledRowTight = styled(Row)`
  margin-bottom: 24px;
`;

export const StyledColVertical = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const StyledCard = styled(Card)`
  cursor: pointer;
  min-height: 280px;
  & .ant-card-body {
    height: 100%;
  }
`;

export const CardItemWrapper: FunctionComponent<any> = styled.div`
  && {
    text-align: left;
    margin: ${(props) => props.theme.noodera.spacing.x8};

    @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
      & > div {
        margin: 0 -${(props) => props.theme.noodera.spacing.x5} 0 0;
      }
    }
  }
`;
export const LearnerHomeContainer: FunctionComponent<any> = styled.div`
  width: 100%;
  margin-left: 0;
  padding: 0;

  && {
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
      padding: 0 ${spacing.x4} ${spacing.x5} ${spacing.x4};
      margin: 0 0 ${spacing.x1};
    }
    @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
      padding: ${spacing.x5};
    }
  }
`;
